document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.querySelector("#mobile-menu-drawer");
  if (!drawer) return;

  // 第2階層スライドパネルを開くボタン
  drawer.querySelectorAll('[data-action="open-submenu"]').forEach((button) => {
    button.addEventListener("click", () => {
      const targetId = button.getAttribute("data-target");
      const panel = document.getElementById(targetId);
      if (!panel) return;

      // aria-expandedをtrueに
      button.setAttribute("aria-expanded", "true");
      panel.setAttribute("aria-hidden", "false");

      // パネルをスライド表示
      panel.classList.add("active");

      // drawer__contentのスクロールをトップに戻す（任意）
      const content = drawer.querySelector(".drawer__content");
      if (content) content.scrollTop = 0;
    });
  });

  // 第2階層スライドパネルの「戻る」ボタン
  drawer.querySelectorAll(".mobile-submenu-back").forEach((button) => {
    button.addEventListener("click", () => {
      const panel = button.closest(".mobile-submenu-panel");
      if (!panel) return;

      // 対応する第1階層ボタンのaria-expandedをfalseに戻す
      const panelId = panel.getAttribute("id");
      const openButton = drawer.querySelector(`[data-target="${panelId}"]`);
      if (openButton) openButton.setAttribute("aria-expanded", "false");

      // パネル非表示
      panel.classList.remove("active");
      panel.setAttribute("aria-hidden", "true");
    });
  });

  // 第3階層アコーディオン用トグルボタン
  drawer.querySelectorAll('button[is="toggle-button"]').forEach((button) => {
    button.addEventListener("click", () => {
      const expanded = button.getAttribute("aria-expanded") === "true";
      const targetId = button.getAttribute("aria-controls");
      const target = document.getElementById(targetId);
      if (!target) return;
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".footer-nav__section");
  function initAccordion() {
    const isMobile = window.matchMedia("(max-width: 740px)").matches;
    sections.forEach((section) => {
      const title = section.querySelector(".footer-nav__title");
      const content = section.querySelector(".footer__item-content");

      if (isMobile) {
        title.addEventListener("click", function () {
          section.classList.toggle("is-open");
        });
      } else {
        section.classList.remove("is-open");
        if (content) {
          content.style.maxHeight = "none";
        }
      }
    });
  }
  initAccordion();
  window.addEventListener("resize", initAccordion);
});


//////////////////////////////////////////
/// 商品詳細
//////////////////////////////////////////

/* alt表示 */
document.addEventListener("DOMContentLoaded", function () {
  const carousel = document.querySelector(".product__media-list");

  if (carousel) {
    const altDisplay = document.createElement("div");
    altDisplay.className = "product-image-alt-text";
    const mediaWrapper = document.querySelector(".product__media-list-wrapper");
    if (mediaWrapper) {
      // create a placeholder so we can move altDisplay back to original position
      const placeholder = document.createElement('div');
      placeholder.setAttribute('data-alt-placeholder', 'true');
      mediaWrapper.parentNode.insertBefore(placeholder, mediaWrapper.nextSibling);

      // Breakpoint consistent with other move scripts
      const breakpoint = 741;

      function moveAltDisplay() {
        if (window.innerWidth >= breakpoint) {
          // append altDisplay as the last child of mediaWrapper
          if (!mediaWrapper.contains(altDisplay)) mediaWrapper.appendChild(altDisplay);
        } else {
          // move altDisplay back after the mediaWrapper (after placeholder)
          if (placeholder.parentNode) {
            placeholder.parentNode.insertBefore(altDisplay, placeholder.nextSibling);
          } else {
            // fallback: put right after the mediaWrapper
            mediaWrapper.parentNode.insertBefore(altDisplay, mediaWrapper.nextSibling);
          }
        }
      }

      // initial placement and on resize with debounce
      moveAltDisplay();
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(moveAltDisplay, 150);
      });
    }
    const productTitle =
      document.querySelector(".product-meta__title")?.textContent.trim() || "";
    function updateAltText() {
      const activeItem = carousel.querySelector(
        ".product__media-item.is-selected img"
      );
      if (activeItem) {
        const altText = activeItem.alt;
        // altが空、または商品タイトルと同じ場合は非表示
        if (!altText || altText === productTitle) {
          altDisplay.textContent = "";
          altDisplay.style.display = "none";
        } else {
          altDisplay.textContent = altText;
          altDisplay.style.display = "block";
        }
      }
    }
    const observer = new MutationObserver(() => {
      updateAltText();
    });
    observer.observe(carousel, {
      attributes: true,
      subtree: true,
      attributeFilter: ["class"],
    });
    updateAltText();
  }
});

/* バリエーションメタフィールドをline item propertyに渡す */
document.addEventListener('DOMContentLoaded', () => {
  const updateVariantTexts = () => {
    const variantId =
      document.querySelector('input[name="id"]')?.value;

    if (!variantId) return;

    document.querySelectorAll('[data-variant-id]').forEach(el => {
      el.hidden = el.dataset.variantId !== variantId;
    });
  };

  // バリエーション選択時にメタフィールド値を更新
  const updateMetafieldProperties = () => {
    const variantId = document.querySelector('input[name="id"]')?.value;
    if (!variantId) return;

    const form = document.querySelector('form[is="product-form"]');
    if (!form) return;

    // Order infoセクションから対応する値を取得
    const leadTimeEl = document.querySelector(`#order_info .lead_time[data-variant-id="${variantId}"]`);
    const salesTypeEl = document.querySelector(`#order_info .sales_type[data-variant-id="${variantId}"]`);

    // Lead Time を更新
    let leadTimeInput = form.querySelector('input[name="properties[Estimated delivery]"]');
    if (leadTimeEl && leadTimeEl.textContent.trim()) {
      const leadTimeValue = leadTimeEl.textContent.trim();
      if (!leadTimeInput) {
        leadTimeInput = document.createElement('input');
        leadTimeInput.type = 'hidden';
        leadTimeInput.name = 'properties[Estimated delivery]';
        form.appendChild(leadTimeInput);
      }
      leadTimeInput.value = leadTimeValue;
    } else if (leadTimeInput) {
      leadTimeInput.remove();
    }

    // Sales Type を更新
    let salesTypeInput = form.querySelector('input[name="properties[Sales Type]"]');
    if (salesTypeEl && salesTypeEl.textContent.trim()) {
      const salesTypeValue = salesTypeEl.textContent.trim();
      if (!salesTypeInput) {
        salesTypeInput = document.createElement('input');
        salesTypeInput.type = 'hidden';
        salesTypeInput.name = 'properties[Sales Type]';
        form.appendChild(salesTypeInput);
      }
      salesTypeInput.value = salesTypeValue;
    } else if (salesTypeInput) {
      salesTypeInput.remove();
    }
  };

  // 初期表示
  updateVariantTexts();
  updateMetafieldProperties();

  // changeを検知したら再判定
  document.addEventListener('change', () => {
    updateVariantTexts();
    updateMetafieldProperties();
  });
});